module.exports = __webpack_public_path__ + "img/UTQUAI-4.be989c75.jpg";